import React from 'react';
import { Link } from 'react-router-dom';

// Left-side branded panel shared by /portal/login and /portal/invite/:token
export default function PortalAuthShell({ children }) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white">
      {/* Branded panel */}
      <div className="hidden lg:flex relative flex-col justify-between p-12 text-white overflow-hidden" style={{ background: 'radial-gradient(circle at 20% 10%, rgba(6,182,212,0.35) 0%, transparent 45%), radial-gradient(circle at 80% 80%, rgba(14,165,233,0.25) 0%, transparent 40%), linear-gradient(135deg, #0f766e 0%, #0d9488 45%, #0891b2 100%)' }}>
        <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)', backgroundSize: '18px 18px' }}></div>
        <div className="relative">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://images.squarespace-cdn.com/content/v1/6329980709c417765c18ef9c/1663928993488-9PHELX1GHR1MGT4SNOLP/minchio+brothers+logo.png?format=100w"
              alt="Minchio Brothers"
              className="h-11 w-11 rounded-lg bg-white/95 p-1"
            />
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-widest text-teal-100 leading-none">Minchio Brothers</div>
              <div className="text-lg font-bold leading-tight">Client Portal</div>
            </div>
          </Link>
        </div>
        <div className="relative">
          <h2 className="text-4xl font-bold leading-tight">Bespoke bookings.<br/>Zero friction.</h2>
          <p className="mt-4 text-teal-50/90 text-lg max-w-md">Your private space to book the packages we’ve tailored for you — with pricing already locked in.</p>
          <ul className="mt-8 space-y-3 text-teal-50">
            <li className="flex items-start gap-3"><span className="mt-1 h-6 w-6 rounded-full bg-white/15 flex items-center justify-center"><i className="ri-check-line"></i></span><span>Your negotiated pricing, always visible</span></li>
            <li className="flex items-start gap-3"><span className="mt-1 h-6 w-6 rounded-full bg-white/15 flex items-center justify-center"><i className="ri-check-line"></i></span><span>One-click booking with real-time availability</span></li>
            <li className="flex items-start gap-3"><span className="mt-1 h-6 w-6 rounded-full bg-white/15 flex items-center justify-center"><i className="ri-check-line"></i></span><span>Reschedule or cancel from any confirmation email</span></li>
          </ul>
        </div>
        <div className="relative text-sm text-teal-100/80">
          &ldquo;They shot our whole portfolio in a week. Portal makes rebooking effortless.&rdquo;
          <div className="mt-1 text-teal-200/70 text-xs">— A repeat corporate client</div>
        </div>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
        <div className="w-full max-w-md">{children}</div>
      </div>
    </div>
  );
}
